export default function Paper(theme) {
    return {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: 4,
                    boxShadow: 'none',
                    border: `1px solid ${theme.palette.grey.A800}`
                }
            }
        }
    };
}
